// extracted by mini-css-extract-plugin
export default {"button":"RoundedButton_button__11MSJ","disableMsg":"RoundedButton_disableMsg__Dukfe"};